// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import { MetaDescription, MetaKeywords } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

const enum fields {
    overrideTitle = "overrideTitle",
}

// XNG-CHANGES: Add overrideTitle field
interface OwnProps extends PageProps {
    fields: {
        [fields.overrideTitle]: string;
    };
}

const LocationFinderPage = ({ id }: OwnProps) => (
    <Page>
        <Zone contentId={id} zoneName="Content" />
    </Page>
);

const pageModule: PageModule = {
    component: LocationFinderPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
        // XNG-CHANGES: Add overrideTitle field and MetaKeywords, MetaDescription
        fieldDefinitions: [
            {
                name: fields.overrideTitle,
                displayName: "Page Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },
            MetaKeywords, MetaDescription
        ],
    },
};

export default pageModule;

export const LocationFinderPageContext = "LocationFinderPage";

